// Copyright aptihealth, inc. 2019 All Rights Reserved

const images = require.context("../assets/images", true);

module.exports = images;
